<template>
  <div>
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane class="paddingBody" :label="$t('Creando workflow')">
        <el-row>
          <el-col :span="24">
            <el-row>
              <el-col :span="22">
                <h1>
                  {{$t('Flujos de aprobación de riesgos')}}
                  <small>{{$t('Crear')}}</small>
                </h1>
              </el-col>
              <el-col :span="2">
                <el-button
                  type="danger"
                  size="medium"
                  style="float: right;"
                  @click="listWorkflows()">
                  Volver
                </el-button>
              </el-col>
            </el-row>
            <br>
          </el-col>

          <el-col :span='24'>
            <el-row>
              <el-col :span="12" :offset="12">
                <WorkflowCreateSteps :step="step" />
              </el-col>
            </el-row>
            <br>
            <el-row>
              <el-col :span="24">
                  <el-button-group
                    style="float: right;">
                    <el-button v-if="step > 1"
                      type="danger"
                      @click.prevent="prev()"
                      size="medium">
                      {{$t('Regresar')}}
                    </el-button>
                    <el-button v-if="step < 3"
                      type="primary"
                      @click.prevent="next()"
                      size="medium">
                      {{$t('Continuar')}}
                    </el-button>
                    <el-button v-if="step === 3"
                      type="primary"
                      @click.prevent="submit()"
                      size="medium">
                      {{$t('Registrar')}}
                    </el-button>
                  </el-button-group>
              </el-col>
            </el-row>
            <br>
            <el-row>
              <el-col :span="24">
                <WorkflowCreate :step="step" :workflow="workflow" />
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import axios from 'axios';
import WorkflowCreateSteps from '@/components/workflows/WorkflowCreateSteps.vue';
import WorkflowCreate from '@/components/workflows/WorkflowCreate.vue';

export default {
  name: 'createWorkflow',
  components: {
    WorkflowCreate,
    WorkflowCreateSteps,
  },
  data() {
    return {
      step: 1,
      workflow: {
        name: null,
        risks: [],
      },
    };
  },
  methods: {
    listWorkflows() {
      this.$router.push({ name: 'workflows' });
    },
    prev() {
      this.step--;
    },
    next() {
      this.step++;
    },
    submit() {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      };
      axios.post('/workflow/crear', this.workflow, config)
        .then((response) => {
          if (response.status === 200) {
            this.$router.push({
              name: 'workflows',
              params: { id: response.data.insertedIds['0'] },
            });
            console.log(response.data);
          } else {
            console.log('error');
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>

<style scoped></style>
